export const UserVI = {
    "notifications":"Thông báo",
    "timekeeping":"Chấm công",
    "payroll":"Bảng lương",
    "personalInformation":"Hồ sơ nhân sự",
    "leaveInformation":"Thông tin nghỉ phép",
    "compensatoryOffInformation":"Thông tin nghỉ bù",
    "account":"Tài khoản",
    "sentEmails":"Gửi email",
    "accessHistory":"Lịch sử truy cập",
    "device":"Thiết bị"
}